// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import moment from 'moment'
// @end

// @import components
import {AllthingsModuleLayout} from 'app_components/modules/academic/allthings'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import PostService from 'app_services/campus/postService'
import CourseService from 'app_services/campus/academic/courseService'
// @end

// @import types
import {IContentInterestItems} from 'app_types/campus/contentInterest/contentInterestTypes'
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @ADD Component types
interface IAllthingsModuleProps {
  type: IContentInterestItems
}
interface IAllthingsModuleState {
  tags: Array<any>
  things: Array<any>
  loading: boolean
  pagination: IPagination
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class AllthingsModule extends Component<IAllthingsModuleProps, IAllthingsModuleState> {

  private nPerPage = 16;
  private type: IContentInterestItems;
  private postService: PostService;
  private courseService: CourseService;

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IAllthingsModuleProps) {
    super(props)
    this.type = props.type
    this.state = {
      tags: [],
      things: [],
      loading: true,
      pagination: {
        page: 1,
        perPage: this.nPerPage,
        total: 0,
      },
    }

    this.postService = new PostService()
    this.courseService = new CourseService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.type === 'moocs') {
      await this.getMoocList()
    } else {
      this.getPostTags()
      await this.getPostList()
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  getPostTags = async () => {
    let tags: Array<any> = []

    const newsResponse = await this.postService.fetchCategories()

    if (newsResponse && newsResponse.categories) {
      tags = newsResponse.categories
    }

    this.setState({
      tags,
    })
  }

  getPostList = async (params?: any) => {

    this.setState({ loading: true })

    let httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      isActive: true,
      postType: [this.type],
      postDate: {
        date: 'today',
        direction: 'lte'
      },
      locations: ['guest'],
      sort: {
        field: 'postDate',
        direction: -1
      }
    }

    if (params && params.tags) {
      httpParams['tags'] = params.tags
    }

    let posts: Array<any> = []
    let pagination: IPagination = {
      total: 0,
      perPage: this.nPerPage,
      page: 1,
    };

    let link: string | null = this.getLink()


    const postsResponse = await this.postService.fetchPosts(httpParams)

    if (postsResponse && postsResponse.posts) {

      posts = postsResponse.posts.reduce((accum: any, element: any) => {
        let postDate = moment.utc(element?.postDate)
        let item = {
          key: element?._id,
          slug: element?.slug,
          cover: element?.coverUrl,
          postDate: postDate.format('DD/MM/YYYY'),
          title: element?.title,
          subtitle: element?.subtitle,
          link,
          authors: element?.authors,
          video: element?.video,
          researchUrl: element?.researchUrl
        }

        accum.push(item)

        return accum
      }, [])

      pagination = {
        total: postsResponse?.total_register,
        perPage: postsResponse?.nPerPage,
        page: postsResponse?.pageNumber,
      }
    }

    this.setState({
      things: posts,
      pagination,
      loading: false
    })
  }


  getMoocList = async (params?: any) => {
    this.setState({ loading: true })

    let httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      startDate: {
        date: 'today',
        direction: 'gte'
      },
      price: 'free',
      publish: true,
    }

    if (params && params.tags) {
      httpParams['tags'] = params.tags
    }

    let courses: Array<any> = []
    let pagination: IPagination = {
      total: 0,
      perPage: this.nPerPage,
      page: 1,
    };

    let link: string | null = this.getLink()

    const coursesResponse = await this.courseService.fetchCourses(httpParams)

    if (coursesResponse && coursesResponse.courses) {

      courses = coursesResponse.courses.reduce((accum: any, element: any) => {
        let startDate = moment.utc(element?.startDate).format('DD/MM/YY')
        let item = {
          key: element?._id,
          elementType: 'moocs',
          ...element,
          startDate,
          link,
        }

        accum.push(item)

        return accum
      }, [])

      pagination = {
        total: coursesResponse?.total_register,
        perPage: coursesResponse?.nPerPage,
        page: coursesResponse?.pageNumber,
      }
    }

    this.setState({
      things: courses,
      pagination,
      loading: false
    })
  }

  onPageChange = async (page: number) => {
    if (this.type === 'moocs') {
      this.getMoocList({ page })
    } else {
      this.getPostList({ page })
    }
  }

  onChangeTag = async (tag: any) => {
    let query: any = {
      page: 1,
      perPage: this.nPerPage,
    }
    if (tag) {
      query['tags'] = [tag._id.toString()]
    }

    if (this.type === 'moocs') {
      // @INFO: Los moocs no tienen categorias
    } else {
      this.getPostList(query)
    }
  }

  getLink = () => {
    let link: string | null = null
    if (this.type === 'moocs') {
      link = '/curso'
    } else if (this.type === 'webinar') {
      link = '/webinar'
    } else if (this.type === 'capsules') {
      link = '/capsula'
    } else if (this.type === 'research') {
      link = '/articulo'
    } else if (this.type === 'blog') {
      link = '/blog'
    } else if (this.type === 'podcast') {
      link = '/podcast'
    } else if (this.type === 'journal') {
      link = '/journals'
    }
    return link
  }

  render() {
    return(
      <AllthingsModuleLayout
        tags={this.state.tags}
        type={this.type}
        things={this.state.things}
        loading={this.state.loading}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        onChangeTag={this.onChangeTag}
      />
    )
  }
}

export default connect(mapStatesToProps)(AllthingsModule)
